export const parseQrContext = (value) => {
  if (value == null) return null;
  let qrId;
  try { qrId = decodeURIComponent(String(value)).trim(); } catch { return null; }
  if (qrId.length > 100 || !/^[TB][A-Za-z0-9_-]+$/.test(qrId)) return null;
  return { qrId, type: qrId[0] === "B" ? "branch" : "table" };
};

export const normalizeOrderType = (value) => {
  const type = String(value || "").trim().toLowerCase();
  if (type.includes("take") || type.includes("parcel") || type.includes("pickup")) return "Pickup";
  if (type.includes("deliver") || type.includes("online")) return "Delivery";
  if (!type || type.includes("dine") || type.includes("sit")) return "Dine In";
  return value;
};
